import React from "react";
import { Editor, DiffEditor } from "@monaco-editor/react";
import TabContainer from "../components/TabContainer";
import { useLocalFileActionsContext } from "../contexts/LocalFileActionsContext";

const EditorContainer = () => {
  const { tabs, closeTab, switchTab, activeTab, updateTabContent } =
    useLocalFileActionsContext();

  const handleTabClick = (fileName) => {
    switchTab(fileName);
  };

  const handleCloseTab = (fileName) => {
    closeTab(fileName);
  };

  const originalContent = activeTab?.originalContent || "";
  const modifiedContent = activeTab?.fileContent || "";

  const shouldUseDiffEditor =
    activeTab?.state === "update" &&
    originalContent.trim() !== modifiedContent.trim();

  console.log("Active tab:", activeTab);
  console.log("Original content:", originalContent);
  console.log("Modified content:", modifiedContent);
  console.log("Should use DiffEditor:", shouldUseDiffEditor);

  const handleDiffEditorDidMount = (diffEditor) => {
    const modifiedEditor = diffEditor.getModifiedEditor();

    // Update `updateTabContent` whenever `modifiedEditor` content changes
    modifiedEditor.onDidChangeModelContent(() => {
      const newContent = modifiedEditor.getValue();
      console.log("DiffEditor content changed:", newContent);
      updateTabContent(activeTab.fileName, newContent);
    });
  };

  const handleEditorDidMount = (editor, monaco) => {
    editor.onDidChangeCursorPosition((e) => {
      console.log(
        `Clicked on Editor at line: ${e.position.lineNumber}, column: ${e.position.column}`
      );
    });

    editor.onDidChangeModelContent((e) => {
      e.changes.forEach((change) => {
        console.log("Change in Editor:", change);
      });
    });
  };

  return (
    <div style={styles.container}>
      <TabContainer
        tabs={tabs}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        handleCloseTab={handleCloseTab}
      />

      {shouldUseDiffEditor ? (
        <DiffEditor
          height="60vh"
          language="javascript"
          theme="vs-dark"
          original={originalContent}
          modified={modifiedContent}
          onMount={handleDiffEditorDidMount}
          options={{
            automaticLayout: true,
            renderSideBySide: true,
            minimap: { enabled: false },
          }}
        />
      ) : (
        <Editor
          height="60vh"
          language="javascript"
          theme="vs-dark"
          value={modifiedContent}
          onMount={handleEditorDidMount}
          onChange={(newContent) =>
            updateTabContent(activeTab.fileName, newContent)
          }
          options={{
            automaticLayout: true,
            minimap: { enabled: false },
          }}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    overflow: "auto",
  },
};

export default EditorContainer;
